export const normalizeLocale = (locale: string) => {
    const [language, region] = locale.split("-");

    return language.toLowerCase() + (region ? `-${region}` : "");
};
